<template>
  <section>
    <b-modal width="680px" :active.sync="isCardModalActive">
      <div class="card" style="border-radius: 5px;">
        <header class="card-header">
          <p class="card-header-title">
            シナリオを削除しますが、本当によろしいでしょうか？
          </p>
        </header>
        <div class="card-content">
          <p>
            <b-message type="is-danger" has-icon>
              削除されたシナリオを復元することはできません。
              またシナリオが繋がれている場合、繋がれた先のシナリオも消されてしまう可能性がございます。
            </b-message>
          </p>
        </div>
        <footer class="card-footer">
          <a class="card-footer-item" @click="isCardModalActive = false">いいえ</a>
          <a class="card-footer-item" @click="clickDeleteScenario()">はい</a>
        </footer>
      </div>
    </b-modal>
  </section>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'ModalDeleteScnario',
  data () {
    return {
      isCardModalActive: false,
      scenarioDelete: null
    }
  },
  computed: {
    ...mapState('chatbot', ['scenarioTable', 'modalScenario', 'isModalDeleteScenario']),
    ...mapState('auth', ['user'])
  },
  watch: {
    isModalDeleteScenario () {
      this.isCardModalActive = this.isModalDeleteScenario
    },
    isCardModalActive () {
      this.isCardModalActive ? console.log('isCardModalActive: true') : this.$store.dispatch('chatbot/closeModalScenario')
    }
  },
  methods: {
    clickDeleteScenario () {
      this.scenarioDelete = this.modalScenario
      this.$store.dispatch('chatbot/deleteScenarioDemo', this.scenarioDelete.beforenode)
      this.$store.dispatch('chatbot/closeModalScenario')
      this.isCardModalActive = false
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/Top/ModalDeleteScenarioDemo.vue